import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CommonService } from "app/services/common/common.service";
import { HttpTestService } from "app/services/http.service";

@Component({
  selector: "app-prepaid-consumption",
  templateUrl: "./prepaid-consumption.component.html",
  styleUrls: ["./prepaid-consumption.component.css"],
})
export class PrepaidConsumptionComponent implements OnInit {
  prepaidValidation_messages = {
    consumerNumber: [
      {
        type: "required",
        message: "Consumer id is mandatory",
      },
      {
        type: "pattern",
        message: "Consumer id is not valid.",
      },
    ],
    consumptionPattern: [
      {
        type: "required",
        message: "Please select consumption pattern",
      },
    ],
    captcha: [
      {
        type: "required",
        message: "Please enter the above captcha",
      },
    ],
  };

  prepaidConsumptionForm: FormGroup;
  public serviceOn: boolean = false;
  public errorMsg: string = "";
  public captchaView: string = "";
  public isCaptchaMatched: boolean = true;

  public query_sec: boolean = true;
  public view_sec: boolean = false;
  public selectedPattern: any;

  public currentConsumptionData: any = "";
  public sevendaysConsumption: any = "";
  public monthlyConsumption: any = "";
  public day = new Date();

  constructor(
    public formBuilder: FormBuilder,
    public commonService: CommonService,
    public httpService: HttpTestService,
    public datePipe: DatePipe
  ) {
    this.initiateForm();
    this.generateCaptcha();

    // let currentDay = this.datePipe.transform(new Date(), 'dd-MM-yyyy')
    // let futureDate = this.datePipe.transform(new Date(new Date().setDate(new Date().getDate()+1)), 'dd-MM-yyyy');

    // let date = new Date();
    // let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    // let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  ngOnInit() {}

  initiateForm() {
    this.prepaidConsumptionForm = this.formBuilder.group({
      consumerNumber: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          // Validators.minLength(7),
          // Validators.maxLength(10),
          // Validators.pattern("^[0-9 ]+$")])),
          Validators.pattern("^[a-zA-Z0-9 ]+$"),
        ])
      ),
      consumptionPattern: new FormControl(
        "",
        Validators.compose([Validators.required])
      ),
      captcha: new FormControl("", Validators.compose([Validators.required])),
    });
  }

  randomString = function (len, an) {
    an = an && an.toLowerCase();
    var str = "",
      i = 0,
      min = an == "a" ? 10 : 0,
      max = an == "n" ? 10 : 62;
    for (; i++ < len; ) {
      var r = (Math.random() * (max - min) + min) << 0;
      str += String.fromCharCode((r += r > 9 ? (r < 36 ? 55 : 61) : 48));
    }
    return str;
  };

  generateCaptcha = function () {
    var self = this;
    self.captchaView = "";
    var cap = self.randomString(3);
    self.captchaView = cap;
  };

  onSearchChange(searchValue: string): void {
    if (searchValue.length == 3) {
      if (searchValue == this.captchaView) {
        this.isCaptchaMatched = true;
      } else {
        this.isCaptchaMatched = false;
      }
    } else {
      this.isCaptchaMatched = true;
    }
  }

  valueChange(event) {
    this.selectedPattern = event.target.value;
    console.log("***",this.selectedPattern)
  }

  checkConsumption() {
    this.serviceOn = true;
    this.query_sec = false;
    this.view_sec = true;
  

    if (this.selectedPattern == "1") {
      // this.currentConsumptionData =
      //   this.commonService.getCurrentConsumption()[0].data[0];
      // console.log("*********", this.currentConsumptionData);
      // this.serviceOn = false;
      this.getPrepaidConsumptionHistories();
    } else if (this.selectedPattern == "2") {
      // this.sevendaysConsumption = this.commonService.getPastSevenDaysCons();
      // let prev;
      // const res = this.sevendaysConsumption.values.map((e: any) => {
      //   const val = e['value'] - (prev || 0);
      //   prev = e['value'];
      //   e['value'] = val;
      //   return e;
      // });
      // console.log("RES ",res);

      this.serviceOn = false;
      console.log(this.sevendaysConsumption);
    } else if (this.selectedPattern == "3") {
      this.serviceOn = false;

      let firstDay = new Date(new Date().getFullYear(), 0, 1);
      let lastDay = new Date(new Date().getFullYear(), 11, 31);

      // console.log(firstDay, "    ", lastDay);

      // console.log("RES ", this.commonService.getMonthlyConsumption());
      // let res = this.commonService.getMonthlyConsumption();

      // let prev;
      // this.monthlyConsumption = res.values.map((e: any) => {
      //   const val = e["value"] - (prev || 0);
      //   prev = e["value"];
      //   e["value"] = val;
      //   return e;
      // });
      // //  this.monthlyConsumption = res;

      // console.log("re-RES", this.monthlyConsumption);
    }
  }

  backToForm() {
    this.serviceOn = true;
    this.initiateForm();
    this.query_sec = true;
    this.view_sec = false;
    this.serviceOn = false;
  }

  getPrepaidConsumptionHistories() {
    console.log("getPrepaidConsumptionHistories")
    let data = {
      consumerNo: this.prepaidConsumptionForm.value.consumerNumber,
    };

    this.httpService.prepaidConsumptionHistories(data).subscribe(
      (data) => {
        console.log("*********************",data['response'])
        this.currentConsumptionData = data['response'];
        this.serviceOn = false;
      },
      (error) => {
        console.log("PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP")
        this.serviceOn = false;
        // this.errorMsg = error;
      },
      () => {}
    );
  }
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/prepaid-consumption/prepaid-consumption.component.ts